<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="form-base__title">
          {{ label }}
        </div>
      </v-col>

      <v-col cols="12">
        <DadataOrgField
          v-model="v.name.$model"
          :errorMessages="getValidationErrorText(v.name)"
          label="Наименование, указанное в ЕГРЮЛ"
          outlined
          :suggestions="suggestions"
          field="name"          
          @suggest="onSelect"           
        />
      </v-col>

      <v-col cols="6">
        <DadataOrgField
          v-model="v.ogrn.$model"
          :errorMessages="getValidationErrorText(v.ogrn)"
          mask="#############"
          label="ОГРН"
          outlined
          :disabled="true"
          :suggestions="suggestions"
          field="ogrn"          
          @suggest="onSelect"           
        />
      </v-col>
      <v-col cols="6">
        <DadataOrgField
          v-model="v.inn.$model"
          :errorMessages="getValidationErrorText(v.inn)"
          mask="##########"
          label="ИНН"
          outlined
          :disabled="true"
          :suggestions="suggestions"
          field="inn"          
          @suggest="onSelect"           
        />
      </v-col>

      <v-col cols="12">
        <div class="form-base__title">
          Сведения о лице, действующем от имени юридического лица без
          доверенности
        </div>
      </v-col>

      <v-col cols="3">
        <v-text-field
          v-model.trim="v.assignee.lastName.$model"
          :errorMessages="getValidationErrorText(v.assignee.lastName)"
          label="Фамилия"
          outlined
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model.trim="v.assignee.firstName.$model"
          :errorMessages="getValidationErrorText(v.assignee.firstName)"
          label="Имя"
          outlined
        />
      </v-col>
      <v-col cols="3">
        <v-text-field
          v-model.trim="v.assignee.patronymic.$model"
          :errorMessages="getValidationErrorText(v.assignee.patronymic)"
          label="Отчество (при наличии)"
          outlined
        />
      </v-col>
      <v-col cols="3">
        <DateFieldCustom
          label="Дата рождения"
          :value="v.assignee.birthDate.$model"
          @change="v.assignee.birthDate.$model = $event"
          :errorMessage="v.assignee.birthDate"
          :max="new Date().toISOString()"
          :disabled="true"
        />
      </v-col>
    </v-row>

    <IdentityDocument
      :v="v.assignee.documents.identityDocument"
      :documents="identityDocuments"
      is-mrpa
    />

    <v-row>
      <v-col cols="6">
        <v-text-field
          v-model="v.assignee.snils.$model"
          :errorMessages="getValidationErrorText(v.assignee.snils)"
          label="СНИЛС"
          v-mask="['###-###-### ##']"
          outlined
          :disabled="true"
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          v-model="v.assignee.inn.$model"
          :errorMessages="getValidationErrorText(v.assignee.inn)"
          label="ИНН"
          v-mask="['############']"
          outlined
          :disabled="true"
        />
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model="v.assignee.email.$model"
          :errorMessages="getValidationErrorText(v.assignee.email)"
          label="Адрес электронной почты"
          outlined
        />
      </v-col>
    </v-row>

    <BaseAuthority :v="v.baseAuthority" />

    <NotaryInfo :v="v" />

    <Assistant v-if="v.assistantJob" :v="v" />
  </div>
</template>

<script>
import DateFieldCustom from '@/components/base/DateFieldCustom';
import IdentityDocument, {
  identityDocumentModel,
  identityDocumentValidation,
} from '@/components/services/elements/IdentityDocument';
import { maxLength, minLength, required } from 'vuelidate/lib/validators';
import {
  EMAIL,
  EMOJI,
  INN_ROD,
  MAX_LENGTH,
  MAX_LENGTH_EMAIL,
  OGRN,
  PERSON_NAME,
} from '@/utils/validate';
import BaseAuthority, {
  baseAuthorityModel,
  baseAuthorityValidation,
} from '@/components/services/ROD/StepApplicant/Machine/BaseAuthority';
import { getValidationErrorText } from '@/utils/validate';
import { IdentityDocumentsRodModule } from '@/store/modules/identityDocumentsRod';
import NotaryInfo, {
  notaryInfoModel,
  notaryInfoValidation,
} from '@/components/services/elements/NotaryInfo';
import Assistant, {
  assistantValidation,
} from '@/components/services/elements/Assistant';
import deepmerge from 'deepmerge';
import DadataOrgField from '@/components/base/DadataOrgField';

export const getTrusteeOrganizationValidation = (trusteeOrganization) => {
  let validation = {
    name: {
      required,
      maxLength: maxLength(1000),
      EMOJI,
    },
    ogrn: {
      required,
      minLength: minLength(13),
      OGRN,
    },
    inn: {
      required,
      minLength: minLength(10),
      INN: INN_ROD,
    },
    assignee: {
      lastName: {
        required,
        maxLength: maxLength(MAX_LENGTH),
        PERSON_NAME,
      },
      firstName: {
        required,
        maxLength: maxLength(MAX_LENGTH),
        PERSON_NAME,
      },
      patronymic: {
        maxLength: maxLength(MAX_LENGTH),
        PERSON_NAME,
      },
      birthDate: {},
      snils: {},
      inn: {},
      email: {
        required,
        EMAIL,
        maxLength: maxLength(MAX_LENGTH_EMAIL),
      },
      documents: {
        identityDocument: identityDocumentValidation,
      },
    },
    baseAuthority: baseAuthorityValidation,
    ...notaryInfoValidation,
  };

  if (trusteeOrganization.assistantJob) {
    validation = deepmerge(validation, assistantValidation);
  }

  return validation;
};

export const trusteeOrganizationModel = {
  name: '',
  ogrn: '',
  inn: '',
  assignee: {
    lastName: '',
    firstName: '',
    patronymic: '',
    birthDate: '',
    snils: '',
    inn: '',
    email: '',
    documents: {
      identityDocument: {
        type: DocumentType.IDENTIFYING,
        ...identityDocumentModel,
      },
    },
  },
  documents: {
    authorityDocument: {
      type: DocumentType.MRP,
      file: null,
      fileSig: null,
    },
  },
  baseAuthority: baseAuthorityModel,
  ...notaryInfoModel,
};

export default {
  name: 'TrusteeOrganization',
  components: {
    DateFieldCustom,
    IdentityDocument,
    BaseAuthority,
    NotaryInfo,
    Assistant,
    DadataOrgField,
  },
  props: {
    v: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    suggestions: [],
    getValidationErrorText,
  }),
  computed: {
    identityDocuments() {
      return IdentityDocumentsRodModule.list;
    },
  },
  async mounted() {
    if (
      !IdentityDocumentsRodModule.loading &&
      !IdentityDocumentsRodModule.loaded
    ) {
      await IdentityDocumentsRodModule.loadAll();
    }
  },
  methods: {
    onSelect: function (item) {
      this.suggestions = [item];
      this.v.name.$model = item.name;
      this.v.inn.$model = item.inn;
      this.v.ogrn.$model = item.ogrn;
    }
  },     
};
</script>
